module.exports = __webpack_public_path__ + "static/stepper-silver-icon-933b70c22a9de245a23cbeb09aaa76d6.svg";